<template>
    <div>
        <div class="field-container">
            <div class="field">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="psion.hasAugment" @change="updateHasAugment">
                    Is Augmentable?
                </label>
            </div>            
        </div>
        <div v-for="augKey in availableAugments" :key="augKey">
            <div class="field-container">
                <hr />
                <h2>Augment {{ augKey }}</h2>
                <div class="field full">
                    <label for="" class="checkbox">
                        <input type="checkbox" :checked="psion.augments[augKey].exists" @change="updateAugmentExists($event, augKey)">
                        Augment {{ augKey }} available?
                    </label>
                </div>
            </div>
            <div v-if="psion.augments[augKey].exists">
                <div class="field-container">
                    <div class="field">
                        <label for="" class="label">Range</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].range" @input="updateAugmentRange($event, augKey)">
                    </div>
                    <div class="field">
                        <label for="" class="label">Target</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].target" @input="updateAugmentTarget($event, augKey)">
                    </div>
                </div>
                <div class="field-container">
                    <div class="field quarter">
                        <label for="" class="checkbox">
                            <input type="checkbox" :checked="psion.augments[augKey].attack.isUnique" @change="updateAugmentAttackIsUnique($event, augKey)">
                            Has Unique Attack?
                        </label>
                    </div>
                    <div class="field quarter" v-if="psion.augments[augKey].attack.isUnique">
                        <label for="" class="checkbox">
                            <input type="checkbox" :checked="psion.augments[augKey].attack.isArea" @change="updateAugmentAttackIsArea($event, augKey)">
                            Is Area?
                        </label>
                    </div>  
                </div>
                <div class="field-container" v-if="psion.augments[augKey].attack.isUnique || psion.augments[augKey].damage.hasDamage">
                    <div class="field quarter">
                        <label for="" class="label">Attack Bonus Type</label>
                        <div class="select">
                            <select name="" id="" :value="psion.augments[augKey].attack.bonusSource" @change="updateAugmentAttackBonusSource($event, augKey)">
                                <option value="weapon">Weapon</option>
                                <option value="implement">Implement</option>
                                <option value="statandbonus">Stat + Static Bonus</option>
                                <option value="static">Static Bonus</option>
                            </select>
                        </div>
                    </div>
                    <div class="field quarter" v-if="psion.augments[augKey].attack.bonusSource != 'static'">
                        <label for="" class="label">Attack Stat</label>
                        <div class="select">
                            <select name="" id="" :value="psion.augments[augKey].attack.stat" @change="updateAugmentAttackStat($event, augKey)">
                                <option value="Strength">Strength</option>
                                <option value="Dexterity">Dexterity</option>
                                <option value="Constitution">Constitution</option>
                                <option value="Intelligence">Intelligence</option>
                                <option value="Wisdom">Wisdom</option>
                                <option value="Charisma">Charisma</option>
                            </select>
                        </div>                    
                    </div>            
                    <div class="field quarter" v-if="isWeaponOrImplement(augKey)">
                        <label for="" class="label">Weapon/Implement #</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].attack.weaponNumber" @input="updateAugmentAttackWeaponNumber($event, augKey)">
                    </div>            
                </div>                
                <div class="field-container" v-if="psion.augments[augKey].attack.isUnique">            
                    <div class="field quarter">
                        <label for="" class="label">Defense</label>
                        <div class="select">
                            <select name="" id="" :value="psion.augments[augKey].attack.defense" @change="updateAugmentAttackDefense($event, augKey)">
                                <option value="AC">AC</option>
                                <option value="Fort">Fort</option>
                                <option value="Ref">Ref</option>
                                <option value="Will">Will</option>                    
                            </select>
                        </div> 
                    </div>
                    <div class="field quarter">
                        <label for="" class="label">Static Attack Bonus</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].attack.staticBonus" @input="updateAugmentAttackStaticBonus($event, augKey)">
                    </div>
                </div>                       
                <div class="field-container">
                    <div class="field quarter">
                        <label for="" class="checkbox">
                            <input type="checkbox" :checked="psion.augments[augKey].damage.hasDamage" @change="updateAugmentDamageHasDamage($event, augKey)">
                            Has Damage?
                        </label>
                    </div>    
                    <div class="field quarter" v-if="psion.augments[augKey].damage.hasDamage">
                        <label for="" class="checkbox">
                            <input type="checkbox" :checked="psion.augments[augKey].damage.addStatMod" @change="updateAugmentDamageAddStatMod($event, augKey)">
                            Add Stat Mod?
                        </label>
                    </div>        
                </div>
                <div class="field-container" v-if="psion.augments[augKey].damage.hasDamage">
                    <div class="field quarter">
                        <label for="" class="label">Dice/[W] Quantity</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].damage.diceQuantity" @input="updateAugmentDamageDiceQuantity($event, augKey)">
                    </div>
                    <div class="field quarter" v-if="psion.augments[augKey].attack.bonusSource != 'weapon'">
                        <label for="" class="label">Dice Sides</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].damage.diceSides" @input="updateAugmentDamageDiceSides($event, augKey)">
                    </div>
                    <div class="field quarter">
                        <label for="" class="label">Static Damage Bonus</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].damage.staticBonus" @input="updateAugmentDamageStaticBonus($event, augKey)">
                    </div>
                    <div class="field quarter">
                        <label for="" class="label">Damage Type</label>    
                        <input type="text" class="input" :value="psion.augments[augKey].damage.type" @input="updateAugmentDamageType($event, augKey)">
                    </div>            
                </div>        
                <div class="field-container">
                    <div class="field">
                        <label for="" class="label">Hit Effect</label>                
                        <textarea name="" id="" cols="30" rows="3" class="textarea" :value="psion.augments[augKey].attack.hitEffect" @input="updateAugmentAttackHitEffect($event, augKey)"></textarea>
                    </div>
                </div>
            </div>            
        </div>        
    </div>        
</template>

<script>
import { mapState } from 'vuex';

export default {  
    props: {
        
    },
    components: {

    },
    data: function() {
        return {
            
        };
    },
    computed: {
        ...mapState({
            psion: state => state.psion,
        }),
        availableAugments() {
            return this.psion.hasAugment ? Object.keys(this.psion.augments) : [];
        }
    },
    methods: {      
        isWeaponOrImplement(index) {
            return this.psion.augments[index].attack.bonusSource == 'weapon' || this.psion.augments[index].attack.bonusSource == 'implement';
        },
        
        updateHasAugment(e) {            
            this.$store.commit('psion/setHasAugment', e.target.checked);        
        },
        updateAugmentExists(e, index) {            
            this.$store.commit('psion/setAugmentExists', {
                value: e.target.checked,
                index
            });            
        },
        updateAugmentRange(e, index) {
            this.$store.commit('psion/setAugmentRange', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentTarget(e, index) {
            this.$store.commit('psion/setAugmentTarget', {
                value: e.target.value,
                index
            });            
        },

        updateAugmentAttackIsUnique(e, index) {
            this.$store.commit('psion/setAugmentAttackIsUnique', {
                value: e.target.checked,
                index
            });            
        },
        updateAugmentAttackIsArea(e, index) {
            this.$store.commit('psion/setAugmentAttackIsArea', {
                value: e.target.checked,
                index
            });            
        },        
        updateAugmentAttackStat(e, index) {
            this.$store.commit('psion/setAugmentAttackStat', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentAttackBonusSource(e, index) {
            this.$store.commit('psion/setAugmentAttackBonusSource', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentAttackDefense(e, index) {
            this.$store.commit('psion/setAugmentAttackDefense', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentAttackStaticBonus(e, index) {
            this.$store.commit('psion/setAugmentAttackStaticBonus', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentAttackWeaponNumber(e, index) {
            this.$store.commit('psion/setAugmentAttackWeaponNumber', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentAttackHitEffect(e, index) {
            this.$store.commit('psion/setAugmentAttackHitEffect', {
                value: e.target.value,
                index
            });            
        },

        updateAugmentDamageHasDamage(e, index) {
            this.$store.commit('psion/setAugmentDamageHasDamage', {
                value: e.target.checked,
                index
            });            
        },
        updateAugmentDamageDiceQuantity(e, index) {
            this.$store.commit('psion/setAugmentDamageDiceQuantity', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentDamageDiceSides(e, index) {
            this.$store.commit('psion/setAugmentDamageDiceSides', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentDamageStaticBonus(e, index) {
            this.$store.commit('psion/setAugmentDamageStaticBonus', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentDamageAddStatMod(e, index) {
            this.$store.commit('psion/setAugmentDamageAddStatMod', {
                value: e.target.value,
                index
            });            
        },
        updateAugmentDamageType(e, index) {
            this.$store.commit('psion/setAugmentDamageType', {
                value: e.target.value,
                index
            });            
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
